// Styling
import styled, { StyledProps } from 'styled-components';

import LogoImage from 'resources/prompto-logo-full-black.svg';

import { useNavigate } from 'react-router-dom';
import { useThemeMode } from 'stores/ThemeContext';

const BarHeight = 60;

const MainWrapper = styled.div`
  width: 100%;
  height: ${BarHeight}px;
  background: ${({ theme }) => theme.background};
  display: flex;
  flex-flow: row;
  align-items: center;
  padding: 0px 20px;
  box-sizing: border-box;
  border-bottom: 1px solid ${({ theme }) => theme.background200};
  margin-bottom: 20px;
`;

const Logo = styled.img`
  height: ${BarHeight - 10}px;
  margin-right: auto;
`;

// const NavigationList = styled.div`
//   display: flex;
//   flex-flow: row;
//   margin-left: auto;
//   margin-right: auto;
//   column-gap: 50px;
// `;

const NavigationButton = styled.div<StyledProps<{ active?: boolean }>>`
  user-select: none;
  cursor: pointer;
  color: ${({ theme, active }) =>
    active ? theme.boldTextColor : theme.mainTextColor};
  margin-left: 20px;
`;

const navigationOptions: { [key: string]: string } = {
  marketplace: 'Marketplace',
  reporting: 'Reporting'
};

// const SoundButton = styled.div`
//   cursor: pointer;
//   background: ${({ theme }) => theme.background200};
//   padding: 4px;
//   border-radius: 4px;
// `;

// const audio1 = new Audio(sound1);
// const audio2 = new Audio(sound2);
// const audio3 = new Audio(sound3);
// const audio4 = new Audio(sound4);

const ThemeToggle = styled.button`
  cursor: pointer;
  background: ${({ theme }) => theme.background200};
  border: 1px solid ${({ theme }) => theme.background300};
  border-radius: 6px;
  padding: 6px 12px;
  color: ${({ theme }) => theme.boldTextColor};
  font-size: 14px;
  margin-left: 20px;
  &:hover {
    background: ${({ theme }) => theme.background300};
  }
`;

const NavigationBar = () => {
  const navigate = useNavigate();
  const { mode, toggleTheme } = useThemeMode();

  interface Button {
    key: string;
    onClick: any;
    text: string;
  }

  const buttons: Array<Button> = [];
  Object.keys(navigationOptions).forEach((key: string, index) => {
    buttons.push({
      key: key,
      onClick: () => {
        navigate(`/${key}`);
      },
      text: navigationOptions[key]
    });
  });

  return (
    <MainWrapper>
      <Logo src={LogoImage} />

      {/* <NavigationButton
        onClick={() => {
          navigate(`/dashboard`);
        }}
      >
        Dashboard
      </NavigationButton> */}
      <NavigationButton
        onClick={() => {
          navigate(`/dashboard`);
        }}
      >
        Live Dashboard
      </NavigationButton>
      <NavigationButton
        onClick={() => {
          navigate(`/reporting`);
        }}
      >
        Reporting
      </NavigationButton>
      <NavigationButton
        onClick={() => {
          navigate(`/tools`);
        }}
      >
        Tools
      </NavigationButton>
      <NavigationButton
        onClick={() => {
          navigate(`/invoicing`);
        }}
      >
        Invoicing
      </NavigationButton>
      <NavigationButton
        onClick={() => {
          navigate(`/ads`);
        }}
      >
        Ad Creator
      </NavigationButton>

      <ThemeToggle onClick={toggleTheme}>
        {mode === 'light' ? 'Dark' : 'Light'}
      </ThemeToggle>

      {/* <NavigationList>
        {buttons.map((button: Button) => {
          return (
            <NavigationButton
              active={window.location.pathname.includes(button.key)}
              onClick={() => {
                button.onClick();
              }}
            >
              {button.text}
            </NavigationButton>
          );
        })}
      </NavigationList> */}
      {/* <Divider />
      <ProfileCard /> */}
      {/* <SoundButton
        onClick={() => {
          const song = Math.floor(Math.random() * (4 - 1 + 1) + 1);

          console.log(song);

          switch (song) {
            default:
            case 1:
              audio1.play();
              break;
            case 2:
              audio2.play();
              break;
            case 3:
              audio3.play();
              break;
            case 4:
              audio4.play();
              break;
          }
        }}
      >
        Test Sound
      </SoundButton> */}
      {/* <button
        onClick={() => {
          sendUnitSoldMessageToSlack("patrick", "karel");
        }}
      >
        Send message
      </button> */}
    </MainWrapper>
  );
};

export default NavigationBar;
